import { render } from "./Navigation.vue?vue&type=template&id=8377744c"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=8377744c&lang=css"

import exportComponent from "/Users/marianne/DevProjects/Marinka backup 29-08-2025/full website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__